import { render, staticRenderFns } from "./manage-product.vue?vue&type=template&id=31495aa1&scoped=true&"
import script from "./manage-product.vue?vue&type=script&lang=js&"
export * from "./manage-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31495aa1",
  null
  
)

export default component.exports